import React from "react";
import ReactPaginate from "react-paginate";

const PaginationComp = ({ viewpage, handlePageClick, pageCount }) => {
  return (
    <div className="bottom-pagination">
      <ReactPaginate
        breakLabel="..."
        nextLabel="Next"
        forcePage={viewpage}
        onPageChange={handlePageClick}
        pageRangeDisplayed={10}
        pageCount={pageCount}
        previousLabel="Prev"
        renderOnZeroPageCount={null}
        activeClassName="p-1"
        activeLinkClassName="pagintion-li"
      />
    </div>
  );
};

export default PaginationComp;
